import { httpStatus } from '@/api-proxy/serviceAvailability'
import { QueryClient, useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/auth'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Always refetch to enable suspense
      gcTime: 1000 * 60 * 10, // 10 minutes
    },
    mutations: {
      // Global auth check for all mutations
      onError: error => {
        if (
          httpStatus(error) === 401 ||
          (error && typeof error === 'object' && 'status' in error && error.status === 401)
        ) {
          useAuthStore.getState().logout()
        }
      },
    },
  },
})

// Helper to invalidate queries by _id
export const invalidateQueriesById = (queryClient: ReturnType<typeof useQueryClient>, queryIds: string[]) => {
  queryIds.forEach(queryId => {
    queryClient.invalidateQueries({
      predicate: query => {
        const firstKey = query.queryKey[0] as { _id?: string } | undefined
        return firstKey?._id === queryId
      },
    })
  })
}
